import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { captureAttribution, initPixel, track } from "@/utils/metaPixel";

/* Monté UNE fois dans <BrowserRouter> :
   - capture fbclid/utm_* à l'arrivée,
   - initialise le pixel si le consentement est déjà donné,
   - envoie exactement un PageView par changement d'URL (SPA). */
export const MetaRouteTracker = () => {
    const location = useLocation();

    useEffect(() => {
        captureAttribution();
        initPixel();
        /* eslint-disable-next-line react-hooks/exhaustive-deps */
    }, []);

    useEffect(() => {
        if (initPixel()) track("PageView");
    }, [location.pathname, location.search]);

    return null;
};
